import {defineStore} from "pinia";
import FormResponseFileAPI from "@/api/FormResponseFileAPI";

export const useFormResponseFileStore = defineStore('form-response-file', {
  state: () => ({
    data: [],
    stats: {},
  }),
  actions: {
    clear() {
      this.data = [];
    },
    zip(id, name, payload) {
      const { params } = payload;

      return new FormResponseFileAPI().zip(id, name, params)
        .then((response) => {
        });
    },
  },
  persist: true,
});
